<template>
  <div class="box">
    <!-- <Header @name="updateTitle($event)"></Header> -->
    <div class="detail">
      <b-container>
        <p class="return" @click="back">
          < 返回案例首页</p> <div class="details_box">
            <img :src="data.navigation" class="img" />
            <h6>{{ data.name }}</h6>
            <p>{{ data.intro }}</p>
            <div class="box">

              <div class="box2 row">
                <div class="col">
                  <img :src="data.ios_url" class="img2" v-show="data.ios_url" />

                </div>
                <div class="col">
                  <img :src="data.android_url" class="img2" v-show="data.android_url" />

                </div>

              </div>
              <div class="row mt-20">
                <div class="col">
                  <a download="文件名.txt" href="#" @click="Ios()" v-if="data.ios">
                    <b-button pill variant="primary" size="sm" class="btn">点击IOS下载
                    </b-button>
                  </a>
                  <b-button pill size="sm" class="btn" v-else disabled>点击IOS下载
                  </b-button>
                </div>
                <div class="col">
                  <a download="文件名.txt" href="#" @click="Android()" v-if="data.android">
                    <b-button pill variant="primary" size="sm" class="btn">点击安卓下载
                    </b-button>
                  </a>
                  <b-button pill size="sm" class="btn" v-else disabled>点击安卓下载
                  </b-button>
                </div>
              </div>

            </div>
    </div>
    </b-container>
  </div>
  <div class="product">
    <div class="box1">
      <h1>项目介绍</h1>
      <span>{{ data.intro }} </span>
    </div>
    <b-container>
      <div class="box">
        <div class="box1" v-if="data.one">
          <img :src="data.one" class="img" />
        </div>
        <div class="box1" v-if="data.two">
          <img :src="data.two" class="img" />
        </div>
        <div class="box1" v-if="data.three">
          <img :src="data.three" class="img" />
        </div>
        <div class="box1" v-if="data.four">
          <img :src="data.four" class="img" />
        </div>
      </div>
    </b-container>
  </div>
  <!-- <Footer></Footer> -->
  </div>
</template>

<script>
  import Header from "@/components/header.vue";
  import Footer from "@/components/footer.vue";
  export default {
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        data: {},
      };
    },
    created() {
      let data = JSON.parse(this.$route.query.data);
      this.data = data;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    mounted() {},
    methods: {

      back() {
        this.$router.push("/case");
      },
      Ios() {
        window.location.href = this.data.ios;
      },
      Android() {
        window.location.href = this.data.android;
      },
    },
  };
</script>

<style lang="less">
  .box {
    position: relative;
  }

  .detail {
    // position: absolute;

    padding: 80px 50px 40px 50px;
    height: 600px;
    width: 92%;
    margin: auto;
    background-image: url("../assets/bg_case.png");
    color: #fff;

    .return {
      font-size: 14px;
      color: #666;
      margin-top: 20px;
    }

    .details_box {
      text-align: center;
      margin-top: 50px;

      .img {
        width: 128px;
        height: 90px;
      }

      h6 {
        font-size: 24px;
        color: #333;
        font-weight: bold;
      }

      p {
        color: #808080;
        margin-top: 10px;
        font-size: 16px;
      }

      .box {
        width: 270px;
        height: 100%;
        // display: flex;
        // justify-content: space-between;
        margin: 0 auto;


        .btn {

          width: 120px;
          margin-top: 35px;
        }

        .box2 {
          text-align: center;

          .img2 {
            width: 110px;
            height: 110px;
          }


        }
      }
    }
  }

  .product {
    margin: 80px 0;

    .box1 {
      text-align: center;
      margin-top: 80px;

      h1 {
        font-size: 24px;
        font-weight: bold;
        color: #333;
      }

      p {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
      }

      span {
        color: #808080;
        font-size: 16px;
      }
    }

    .box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .box1 {
        width: 48%;

        .img {
          width: 397px;
        }
      }
    }
  }
</style>